var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("content-container", [
    _c("section", { staticClass: "allergy-filter-wrapper" }, [
      _c("span", { staticClass: "allergy-filter-text" }, [
        _vm._v("Filter by: "),
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "allergy-filter-list" },
        _vm._l(_vm.filters, function (filter) {
          return _c(
            "li",
            { key: filter.id },
            [
              _c("allergy-filter", {
                attrs: {
                  id: filter.id,
                  value: filter.value,
                  icon: filter.icon,
                  label: filter.label,
                  isSelected: _vm.isFilterSelected(filter.id),
                },
                on: { change: _vm.handleFilterChange },
              }),
            ],
            1
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }